import { render } from "./v-popup-login.vue?vue&type=template&id=517ffd0c&scoped=true"
import script from "./v-popup-login.vue?vue&type=script&lang=js"
export * from "./v-popup-login.vue?vue&type=script&lang=js"

import "./v-popup-login.vue?vue&type=style&index=0&id=517ffd0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-517ffd0c"

export default script